import {ModulePages} from "../../core/module-pages";
import {ListProcessPage} from "./pages/list.process.page";

export function ProcessModule(props: any) {
  return (
    <ModulePages routes={[
        { path: 'list', render: (props) => <ListProcessPage {...props} />},
        { path: '', render: (props) => <ListProcessPage {...props} />},
      ]}
    />
  )
}
